// extracted by mini-css-extract-plugin
export default {"career-info-title":"CareerInfo_career-info-title__lI6+i","career-info":"CareerInfo_career-info__XGtUI","career-info-container":"CareerInfo_career-info-container__whDDT"};